/* Ondeloria — interactions. Aucune dépendance. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Apparition au défilement. */
  function initReveal() {
    var items = document.querySelectorAll('[data-onde-reveal]:not(.is-in)');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* 2. Onglets (pièce par pièce, tailles). */
  function initRooms(root) {
    if (root.dataset.ondeRoomsReady) return;
    root.dataset.ondeRoomsReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function select(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        var panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-active', on);
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        select(next);
        tabs[next].focus();
      });
    });
  }

  /* 3. La pièce : points chauds sur l'image. */
  function initScene(root) {
    if (root.dataset.ondeSceneReady) return;
    root.dataset.ondeSceneReady = '1';

    var spots = Array.prototype.slice.call(root.querySelectorAll('[data-onde-spot]'));
    if (!spots.length) return;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function cardOf(btn) { return root.querySelector('#' + btn.getAttribute('aria-controls')); }

    function close(except) {
      spots.forEach(function (b) {
        if (b === except) return;
        b.setAttribute('aria-expanded', 'false');
        var c = cardOf(b);
        if (c) c.classList.remove('is-open');
      });
    }

    function place(btn) {
      var card = cardOf(btn);
      if (!card) return;
      var x = parseFloat(btn.style.left) || 50;
      var y = parseFloat(btn.style.top) || 50;
      card.style.left = Math.min(Math.max(x, 18), 82) + '%';
      card.style.top = y > 55 ? 'auto' : (y + 4) + '%';
      card.style.bottom = y > 55 ? (100 - y + 4) + '%' : 'auto';
      card.style.transform = 'translateX(-50%)';
    }

    function open(btn) {
      close(btn);
      btn.setAttribute('aria-expanded', 'true');
      var c = cardOf(btn);
      if (c) { place(btn); c.classList.add('is-open'); }
    }

    spots.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.getAttribute('aria-expanded') === 'true') { close(null); } else { open(btn); }
      });
      btn.addEventListener('focus', function () { open(btn); });
      if (fine) {
        btn.addEventListener('mouseenter', function () { open(btn); });
      }
    });

    root.addEventListener('mouseleave', function () { if (fine) close(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(null); });
    if (spots[0]) open(spots[0]);
  }

  /* 4. Fiche produit : galerie empilée, voir plus, variantes. */
  function initPdp(root) {
    if (root.dataset.ondePdpReady) return;
    root.dataset.ondePdpReady = '1';

    var more = root.querySelector('[data-onde-more]');
    if (more) {
      more.addEventListener('click', function () {
        root.querySelectorAll('.onde-shot.is-hidden').forEach(function (el) { el.classList.remove('is-hidden'); });
        more.remove();
      });
    }

    var select = root.querySelector('[data-onde-ids]');
    if (!select) return;

    var variants = Array.prototype.slice.call(select.options).map(function (o) {
      return {
        id: o.value,
        opts: (o.dataset.opts || '').split('||'),
        price: o.dataset.price || '',
        available: o.dataset.available === 'true'
      };
    });

    var sets = Array.prototype.slice.call(root.querySelectorAll('[data-onde-opt]'));
    var chosen = sets.map(function (set) {
      var on = set.querySelector('.onde-pdp__pill.is-on');
      return on ? on.dataset.ondeVal : '';
    });

    var priceEl = root.querySelector('[data-onde-price]');
    var summaryEl = root.querySelector('[data-onde-summary]');
    var addBtn = root.querySelector('[data-onde-add]');
    var soldOut = (addBtn && addBtn.dataset.soldOut) || 'Sold out';
    var addLabel = addBtn ? addBtn.textContent.trim() : 'Add to cart';

    function match(values) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var k = 0; k < values.length; k++) {
          if (variants[i].opts[k] !== values[k]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function paint() {
      sets.forEach(function (set, si) {
        set.querySelectorAll('.onde-pdp__pill').forEach(function (pill) {
          var val = pill.dataset.ondeVal;
          var on = chosen[si] === val;
          pill.classList.toggle('is-on', on);
          pill.setAttribute('aria-pressed', on ? 'true' : 'false');
          var probe = chosen.slice();
          probe[si] = val;
          var v = match(probe);
          pill.classList.toggle('is-off', !v || !v.available);
        });
        var label = set.querySelector('[data-onde-optval]');
        if (label) label.textContent = chosen[si];
      });

      var v = match(chosen);
      if (!v) return;
      select.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addLabel : soldOut;
      }
      if (summaryEl) summaryEl.textContent = chosen.join(' · ');
      var viewer = document.querySelector('[data-onde-model]');
      if (viewer && viewer.dataset.modelBlack && viewer.dataset.modelBrass) {
        var brass = chosen.join(' ').toLowerCase().indexOf('brass') !== -1;
        var next = brass ? viewer.dataset.modelBrass : viewer.dataset.modelBlack;
        if (viewer.getAttribute('src') !== next) viewer.setAttribute('src', next);
      }
    }

    sets.forEach(function (set, si) {
      set.querySelectorAll('.onde-pdp__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          chosen[si] = pill.dataset.ondeVal;
          paint();
        });
      });
    });

    var qtyIn = root.querySelector('[data-onde-qtyin]');
    root.querySelectorAll('[data-onde-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyIn) return;
        var next = (parseInt(qtyIn.value, 10) || 1) + parseInt(btn.dataset.ondeQty, 10);
        qtyIn.value = Math.min(9, Math.max(1, next));
      });
    });

    paint();
  }

  function boot(scope) {
    var where = scope || document;
    where.querySelectorAll('[data-onde-rooms]').forEach(initRooms);
    where.querySelectorAll('[data-onde-scene]').forEach(initScene);
    where.querySelectorAll('[data-onde-pdp]').forEach(initPdp);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
